var render, staticRenderFns
import script from "./CauseStats.vue?vue&type=script&lang=js&"
export * from "./CauseStats.vue?vue&type=script&lang=js&"
import style0 from "./CauseStats.vue?vue&type=style&index=0&id=31cade4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cade4b",
  null
  
)

export default component.exports